export default __webpack_public_path__ + "static/media/mesh.566efd49.png";